'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../providers/iframeMessaging/index.js');
var messageSchemas = require('../providers/iframeMessaging/messageSchemas.js');
var nthHookSettings = require('@narvar/nth-hook-settings');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

let IFRAME_HEIGHT = /*#__PURE__*/function (IFRAME_HEIGHT) {
  IFRAME_HEIGHT[IFRAME_HEIGHT["TALL"] = 750] = "TALL";
  IFRAME_HEIGHT[IFRAME_HEIGHT["SHORT"] = 450] = "SHORT";
  return IFRAME_HEIGHT;
}({});
const IframeHeight = _ref => {
  let {
    children,
    height
  } = _ref;
  const {
    supportPlatformOrigins
  } = nthHookSettings.useSettings();
  const iframeHeight = height ?? IFRAME_HEIGHT.TALL;
  React.useEffect(() => {
    const message = {
      type: messageSchemas.MESSAGE_TYPES.SET_IFRAME_HEIGHT,
      payload: {
        height: iframeHeight
      }
    };
    index.sendIframeMessage({
      message,
      origins: supportPlatformOrigins
    });
  }, [iframeHeight, supportPlatformOrigins]);
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, children);
};
var IframeHeight$1 = nthHookSettings.withSettingsProvider(IframeHeight, {
  settingsRequested: 'supportPlatformOrigins'
});

exports.IFRAME_HEIGHT = IFRAME_HEIGHT;
exports["default"] = IframeHeight$1;
